module.exports = __webpack_public_path__ + "img/20190524103809未标题-3.3e0b5d9d.png";